import Header from "../Header";
import { LoadingMessage } from "../LoadingMessage";

interface Props {
  message: string;
}

export function LoadingWithHeader({ message }: Props) {
  return (
    <>
      <Header />
      <br />
      <LoadingMessage message={message} showGoToRootPageAfterMs={4000} />
    </>
  );
}
